import { useEffect, useState } from "react";
import "./media.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useNavigate, useParams } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

const mediaEditEndpoint = ApiEndpoints.adminMedia.adminMediaEdit;
const mediaUpdateEndpoint = ApiEndpoints.adminMedia.adminMediaUpdate;

export default function EditMedia() {
  const { media_id } = useParams();
  const navigate = useNavigate();
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [data, setData] = useState(
    {
      title: "",
      link: "",
      thumbnail_image: null,
      logo: null,
      created_by: "admin",
      createdAt: new Date().toISOString(),
    }
  );

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", `${mediaEditEndpoint}${media_id}`);
        const result = response.media;
        setData(result);

        setThumbnailPreview(
          response?.media.thumbnail_image ? `${BaseUrl}${response.media.thumbnail_image}` : null
        );

        setLogoPreview(
          response?.media.logo ? `${BaseUrl}${response.media.logo}` : null
        );

      } catch (error) {
        console.log("Error fetching media data:", error);
      }
    };
    dataFetch();
  }, [mediaEditEndpoint, media_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Prevent spaces in the `link` field
    if (name === "link") {
      const filteredValue = value.replace(/\s/g, ""); // Remove spaces
      setData((prevData) => ({
        ...prevData,
        [name]: filteredValue,
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle file input changes for image uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (name === "thumbnail_image") {
          setThumbnailPreview(reader.result);
        } else if (name === "logo") {
          setLogoPreview(reader.result);
        }
      };
      reader.readAsDataURL(file);

      setData((prevData) => ({
        ...prevData,
        [name]: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }

    try {
      await ApiRequest("POST", `${mediaUpdateEndpoint}${media_id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Media Updated Successfully!");
      navigate("/admin/media");
    } catch (error) {
      toast.error(error)
    }
  };
  return (
    <>
      <div className="header-add-category">
        <h5>Edit Media</h5>
      </div>
      <div className="add-media-content">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Title */}
            <div className="col-md-12">
              <label>Title:*</label>
              <input
                name="title"
                required
                type="text"
                className="form-control"
                value={data.title}
                onChange={handleInputChange}
              />
            </div>

            {/* link Input */}
            <div className="col-md-12">
              <label>Link:*</label>
              <input
                name="link"
                required
                type="text"
                className="form-control"
                value={data.link}
                onChange={handleInputChange}
              />
            </div>

            {/* Date Input */}
            <div className="col-md-12">
              <label>Creation Date:*</label>
              <input
                name="createdAt"
                required
                type="date"
                className="form-control"
                value={
                  data.createdAt
                    ? data.createdAt.split("T")[0] // Ensure only the date part is displayed
                    : ""
                }
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  if (selectedDate) {
                    const newDate = `${selectedDate}T00:00:00.000+00:00`;
                    setData((prevData) => ({
                      ...prevData,
                      createdAt: newDate,
                    }));
                  }
                }}
              />
            </div>


            {/* card Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Thumbnail Image (510 x 400 px):</label>
                <input
                  name="thumbnail_image"
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />
                {thumbnailPreview && (
                  <img
                    src={thumbnailPreview}
                    alt="Preview"
                    style={{ width: "100px", maxHeight: "300px", marginTop: "5px" }}
                  />
                )}
              </div>
            </div>

            {/* media logo Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="bannerImage">Media Logo (140 x 28 px)</label>
                <input
                  name="logo"
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />

                {logoPreview && (
                  <img
                    src={logoPreview}
                    alt="Preview"
                    style={{ width: "100px", maxHeight: "300px", marginTop: "5px" }}
                  />
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button onClick={() => console.log(data)} type="submit" className="btn btn-primary submit-formbtn">
                Edit Media
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
